export default __webpack_public_path__ + "static/media/silvia.6095e92f.png";